import {
  ParagraphText,
  StackLayout,
  TextAction,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { EXTERNAL_LINKS } from 'common/links';

const DisclaimerLinkWrapper = (text: React.ReactNode) => (
  <TextAction
    href={EXTERNAL_LINKS.DISCLAIMER}
    target="_blank"
    rel="noopener noreferrer"
    css={{ typography: '$caption', display: 'inline' }}
  >
    {text}
  </TextAction>
);

const DisclaimerLinkText = () => {
  const { formatMessage } = useIntl();

  return (
    <ParagraphText css={{ typography: '$caption', display: 'inline' }}>
      {formatMessage(
        { id: 'STR_FOOTER_DISCLAIMER_FULL_LINK' },
        {
          a: DisclaimerLinkWrapper,
        },
      )}
    </ParagraphText>
  );
};

export const Disclaimer = () => {
  const { formatMessage, messages } = useIntl();
  const year = new Date().getFullYear();

  const disclaimerText = formatMessage(
    { id: 'STR_FOOTER_DISCLAIMER' },
    { year },
  );
  const copyrightText = formatMessage({ id: 'STR_FOOTER_COPYRIGHT' }, { year });

  return (
    <StackLayout spacing="$oneAndHalf">
      <StackLayout spacing="$half" css={{ width: '100%' }}>
        <UtilityText as="p" css={{ typography: '$caption', display: 'inline' }}>
          {disclaimerText}
        </UtilityText>
        {!!messages.STR_FOOTER_DISCLAIMER_FULL_LINK && <DisclaimerLinkText />}
      </StackLayout>

      <ParagraphText css={{ typography: '$caption', fontWeight: '500' }}>
        {copyrightText}
      </ParagraphText>
    </StackLayout>
  );
};
